import React, { useState, useEffect } from 'react'
import { ArrowRight, X } from 'lucide-react'

export default function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false)
  const [isDismissed, setIsDismissed] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero section (about 500px)
      if (window.scrollY > 500 && !isDismissed) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [isDismissed])

  if (!isVisible || isDismissed) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden animate-slideUp">
      {/* Gradient background */}
      <div className="bg-gradient-to-r from-cyan-600 via-cyan-500 to-blue-500 px-4 py-3 shadow-2xl border-t border-cyan-400/30">
        <div className="flex items-center justify-between gap-3 max-w-lg mx-auto">
          {/* Text */}
          <div className="flex-1 min-w-0">
            <div className="text-white font-bold text-sm truncate">
              Only P***/month
            </div>
            <div className="text-cyan-100 text-xs truncate">
              All features included
            </div>
          </div>

          {/* CTA Button */}
          <a
            href="https://app.laundrymate.shop"
            className="flex-shrink-0 inline-flex items-center gap-1.5 bg-white text-cyan-600 px-5 py-2.5 rounded-lg font-bold text-sm transition-all hover:scale-105 active:scale-95 shadow-lg"
          >
            Get Started
            <ArrowRight className="w-4 h-4" />
          </a>

          {/* Dismiss button */}
          <button
            onClick={() => setIsDismissed(true)}
            className="flex-shrink-0 p-1.5 text-white/70 hover:text-white transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }
      `}</style>
    </div>
  )
}
